export default {
  en: {
    newPromotion: 'New Promotion',
    promotion: 'Promotion',
    code: 'Code',
    detail: 'Detail',
    minNight: 'Min Night',
    maxNight: 'Max Night',
    periodOfStay: 'Period of Stay',
    addPeriod: 'Add Period',
    status: 'Status',
    createPromotion: 'Create Promotion',
    cancel: 'Cancel',
    createPromotionSuccessTitle: 'Success',
    createPromotionSuccessMessage: 'Create Promotion Success.',
    alertOverlap: 'Period is Overlap',
    applyRoomType: 'Apply Room Type'
  },
  th: {
    newPromotion: 'สร้างโปรโมชั่น',
    promotion: 'เรท',
    code: 'รหัส',
    detail: 'รายละเอียด',
    minNight: 'Min Night',
    maxNight: 'Max Night',
    periodOfStay: 'ช่วงเวลาโปรโมชั่น',
    addPeriod: 'เพิ่มช่วงเวลา',
    status: 'สถานะ',
    createPromotion: 'สร้างโปรโมชั่น',
    cancel: 'ยกเลิก',
    createPromotionSuccessTitle: 'สำเร็จ',
    createPromotionSuccessMessage: 'สร้างโปรโมชั่นสำเร็จ',
    alertOverlap: 'ช่วงเวลาซ้อนทับกัน',
    applyRoomType: 'เลือกใช้ประเภทห้อง'
  }
}
